module.exports = __webpack_public_path__ + "img/maker_tray.928cbc01.jpg";